module.exports = __webpack_public_path__ + "img/openbb_logo.e2673b81.png";